import React, { useState } from "react";
import { SelectChangeEvent, TextField, MenuItem, Select, Button, FormControlLabel, Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditText from "../../components/editText";

const AddCampaignType = () => {

  const navigate = useNavigate();
  const [eventType, setEventType] = React.useState('default');
  const handleEventTypeChange = (event: SelectChangeEvent) => {
    setEventType(event.target.value as string);
  };
  const [legal1, setLegal1] = useState<string>("");

  return (
    <>
      <div className="main_title">
        <h1>Add Campaign Type</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-system-settings")}> Settings</button> -
          Add Email Template
        </p>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            <div className="control_group w_50">
              <label htmlFor="temp_name">Title</label>
              <TextField
                id="temp_name"
                placeholder="Enter Title "
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label htmlFor="temp_name">Description</label>
              <TextField
                id="temp_name"
                placeholder="Enter Descrpition "
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label htmlFor="temp_eventType"> Type</label>
              <Select
                id="temp_eventType"
                fullWidth
                value={eventType}
                onChange={handleEventTypeChange}
              >
                <MenuItem disabled value="default">Select Event Type</MenuItem>
                <MenuItem value="1">Free</MenuItem>
                <MenuItem value="2">Paid</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label htmlFor="temp_title">Amount</label>
              <TextField
                id="temp_title"
                placeholder="Enter Amount"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_100">
              <label htmlFor="features">Features</label>

              <div className="features_box">
                <FormControlLabel
                  label="Add Products"
                  control={<Switch />}
                />

                <FormControlLabel
                  control={<Switch />}
                  label="Add Categories"
                />

                <FormControlLabel
                  control={<Switch />}
                  label="Add Image Upload"
                />

                <FormControlLabel
                  control={<Switch />}
                  label="Add Discount Type (Percentage / Fixed)"
                />

                <FormControlLabel
                  control={<Switch />}
                  label="Minimum Purchase Amount"
                />

                <FormControlLabel
                  control={<Switch />}
                  label="Add Specific Products"
                />

                <FormControlLabel
                  control={<Switch />}
                  label="Combo Offer"
                />
                <FormControlLabel
                  control={<Switch />}
                  label="Buy X get Y free"
                />
              </div>
            </div>



          </div>
          <div className="form_btn">
            <Button className="btn btn_primary" >Submit</Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddCampaignType;
